import React, { Component,PureComponent } from 'react'
import NavigationItems from './Components/NavigationItems'
import PageHeader from './Components/PageHeader'
import Footer from './Components/Footer'
import axios from 'axios'
import Base from './Config'
import WaveLoading from 'react-loadingg/lib/WaveLoading';
import {NotificationContainer, NotificationManager} from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import { Modal,ButtonToolbar,Button } from 'react-bootstrap';


class ListItems extends PureComponent {
    constructor(){
        super()
        this.state={
            default:false
        }
    }
    clicked=(e,id)=>{
        // console.log('item id',this.props.users.id);
        // console.log('checked',e.target.checked);
        if(e.target.checked){
            // console.log(this.props.users.id,' add to array');
            this.props.addToArray(this.props.users.id)
        }
        else{
            // console.log(this.props.users.id,' remove from array');
            this.props.removeFromArray(this.props.users.id)

        }
    }
    

    render() {
        // let check = this.props.users
        // console.log('check ',check);
        let data = this.props.users
        // console.log('data ',data);
        return (
            <li className="list-group-item">
                <div className="custom-control custom-checkbox mr-sm-2">
                    <input checked={data.checked}  onChange={this.clicked} type="checkbox" className="custom-control-input" id={data.id} />
                    <label className="custom-control-label" htmlFor={data.id}>{data.user_type==="T"?"Tenant : ":"Outsider : "}:{data.username}</label>
                </div>
            </li>
        )
    }
}

class MyVerticallyCenteredModal extends React.Component {
    constructor(){
        super()
        this.state = {
            data:[],
            next:null,
            prev:null,
            loading:true,

            fortenant:false,
            foroutsider:false,
            individual:false,
            individualList:[],

            loader:false,

            search:"",
            filteredData:[],

            notificationData:[],
        }
    }

    componentDidMount(){
        this.fetchAllUsers()
    }
    
    submitForm=()=>{
        // console.log('submit');
        // console.log('state ',this.state.individualList);
        this.props.setlist(this.state.individualList)
        // let data = []
        // data.push({'orderid':this.props.id,'details':this.state})
        // this.props.MakeQuotation(data)
        this.clearData()
        this.props.onHide()
    }
    fetchAllUsers(){
        // this.loading(true)
        // console.log('read all data');
        
        axios.get(
            Base.url + 'UserAdditional',
            {
                headers: {
                    'Authorization': 'Token ' + localStorage.getItem('Token'),
                    
                }
            }
        ).then(response => {
            // console.log('Response all :', response);
            // console.log('Response all :', response.data);
            let modifiedData = []

            response.data.map((item)=>
                modifiedData.push({
                    id:item.id,
                    username:item.user.username,
                    user_type:item.user_type,
                    checked:false
                })
            )
            // console.log('modified data ',modifiedData);
            this.setState({
                data: modifiedData,
                // next: response.data.next,
                // prev: response.data.previous,
                filter:false,
                loading:false
            })
        }).catch(error => {
            console.log('Error loading quotation count: ', error);
            NotificationManager.error('Error : ', error, 10000);
        })
    }


    onChange=(e)=>{
        let search = e.target.value
        // console.log('Search ',search);
        
        this.setState ({
            [e.target.name]:e.target.value
        },()=>{
        
        })


        const newData = this.state.data.filter(item => {      
            const itemData = `${item.username.toUpperCase()}`;
            const textData = search.toUpperCase();
            return itemData.indexOf(textData) > -1;    
        });
        // console.log("newData :",newData);
        this.setState({ filteredData: newData });  
    }

    changePrevState=(id)=>{
        let newData = []
        let newFiteredData = []
        
        this.state.data.map((item)=>{
            if(item.id ==id){
                // console.log('item ',item);
                
                newData.push({
                    id:item.id,
                    username:item.username,
                    user_type:item.user_type,
                    checked:!item.checked
                })
            }
            else{
                newData.push({
                    id:item.id,
                    username:item.username,
                    user_type:item.user_type,
                    checked:item.checked
                })
            }
        })

        this.state.filteredData.map((item)=>{
            if(item.id ==id){
                // console.log('item ',item);
                
                newFiteredData.push({
                    id:item.id,
                    username:item.username,
                    user_type:item.user_type,
                    checked:!item.checked
                })
            }
            else{
                newFiteredData.push({
                    id:item.id,
                    username:item.username,
                    user_type:item.user_type,
                    checked:item.checked
                })
            }
        })

        this.setState({
            data :newData,
            filteredData:newFiteredData
        })

    }

    add=(id)=>{
        this.changePrevState(id)

        this.setState({
            individualList: [ ...this.state.individualList, id],
        }, () => {
            // console.log(this.state.individualList);
        });
    }
    remove=(id)=>{
        this.changePrevState(id)

        let remove = this.state.individualList.indexOf(id);
        this.setState({
            individualList: this.state.individualList.filter((_, i) => i !== remove)
        },
            () => {
            // console.log('fruits', this.state.individualList);
        }
        );
    }


    clearData=()=>{
        let newdata=[]
        this.state.data.map((item)=>{
            newdata.push({
                id:item.id,
                username:item.username,
                user_type:item.user_type,
                checked:false
            })
         })
      
        this.setState({
            filteredData:newdata,
            data : newdata,

            fortenant:false,
            foroutsider:false,
            individual:false,
            individualList:[],

            loader:false,

            search:"",
        })
    }

    onChange=(e)=>{
        let search = e.target.value
        // console.log('Search ',search);
        
        this.setState ({
            [e.target.name]:e.target.value
        },()=>{
        
        })


        const newData = this.state.data.filter(item => {      
            const itemData = `${item.username.toUpperCase()}`;
            const textData = search.toUpperCase();
            return itemData.indexOf(textData) > -1;    
        });
        // console.log("newData :",newData);
        this.setState({ filteredData: newData });  
    }


    render() {
        return (
            <Modal
                show={this.props.show}
                onHide={this.props.onHide}
                // {...this.props}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >

            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Quotation Details
            </Modal.Title>
                </Modal.Header>
                <Modal.Body >
                
                    <div className="form-group">
                        <div className="input-group input-group-alternative mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text"></span>
                            </div>
                            
                            <input name="search" value={this.state.search} onChange={this.onChange} className="form-control " placeholder="search user" type="text" />
                            <button type="button" className="btn btn-sm btn-white " onClick={this.addPromocode}><i className="fa fa-search" aria-hidden="true"></i></button>

                        </div>
                    </div>
                    <div className="form-group">
                        
                        <div className="input-group input-group-alternative ">

                                <span className="col-lg" style={{minHeight:300,maxHeight:400,overflowY:"scroll"}}>
                                {/* <label className="mr-6 pl-2 mt-2" >User Type</label><label className="pr-3" htmlFor="check1">Username</label> */}

                                <ul className=" list-group list-group-flush ">
                                    
                                {this.state.filteredData.length==0?this.state.data.map((data,index)=> {
                                    return(
                                        <ListItems 
                                        users={data} 
                                        key={index} 
                                        addToArray={this.add}
                                        removeFromArray={this.remove}
                                        />
                                    )}
                                )
                                :
                                this.state.filteredData.map((data,index)=> {
                                    return(
                                        <ListItems 
                                        users={data} 
                                        key={index} 
                                        addToArray={this.add}
                                        removeFromArray={this.remove}
                                        individual={this.state.individual}
                                        />
                                    )}
                                )
                                }
                                
                                </ul>
                                </span>
                            </div>
                    </div>

    
                    <div className="text-center text-muted mb-4">
                        {/* <small>Or sign up with credentials</small> */}
                    </div>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={this.submitForm}>Submit</Button>
            </Modal.Footer>
        </Modal>
        )
    }
}
class ListUserModal extends React.Component {
    constructor(){
        super()
        this.state = {
        }
    }

    render() {
        const data = this.props.data
        // console.log('data : ',data);
        
        return (
            <Modal
                show={this.props.show}
                onHide={this.props.onHide}
                // {...this.props}
                size="sm"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >

            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Promocode users
            </Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    {/* <div className="form-group">
                        <div className="input-group input-group-alternative mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text"></span>
                            </div>
                            
                            <input name="search" value={this.state.search} onChange={this.onChange} className="form-control " placeholder="search user" type="text" />
                            <button type="button" className="btn btn-sm btn-white " onClick={this.addPromocode}><i className="fa fa-search" aria-hidden="true"></i></button>

                        </div>
                    </div> */}
                    <div className="form-group">
                        
                        <div className="input-group input-group-alternative ">

                                <span className="col-lg" style={{minHeight:200,maxHeight:700,overflowY:"scroll"}}>
                                {/* <label className="mr-6 pl-2 mt-2" >User Type</label><label className="pr-3" htmlFor="check1">Username</label> */}

                                <ul className=" list-group list-group-flush ">
                                    
                                {data.map((data,index)=> {
                                    return(
                                        <li key={index} className="list-group-item">
                                            <div className="mr-sm-2">
                                                <label className="" htmlFor={data.id}>{data.user_type==="T"?"Tenant ":"Outsider "}:{data.user.username}</label>
                                            </div>
                                        </li>
                                    )}
                                )
                                
                                }
                                
                                </ul>
                                </span>
                            </div>
                    </div>

    
                    <div className="text-center text-muted mb-4">
                        {/* <small>Or sign up with credentials</small> */}
                    </div>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={this.props.onHide}>Close</Button>
            </Modal.Footer>
        </Modal>
        )
    }
}


class Items extends PureComponent {
    constructor(){
        super()
        this.state={
            modalShow:false,
        }
    }

    edit=()=>{
        // console.log('Edit ',this.props.data);
        this.props.Edit(this.props.data)
    }

    delete=()=>{
        // console.log('delete ',this.props.data);
        this.props.Delete(this.props.data)
    }

    render() {
        // console.log('props : ',this.props.data);
        const data = this.props.data
        // console.log('date ',data.code);

        // console.log('date ',data.expiry_date);

        const date = new Date(data.expiry_date)
        // console.log('date ',date.toDateString());
        
        
        return (
            <tr>
                <th scope="row">
                {data.code}
                
                {data.recurrence&&<><br/>Recurrence : {data.recurrence}</>}
                {data.expiry_date&&<><br/>Validity : {date.toDateString()}</>}
                
                </th>
                <td>{data.disc_perc}</td>
                <td>
                {
                data.is_active?
                <i className="fa fa-check-circle" style={{ fontSize: 20, color: 'green' }} />
                :
                <i className="fa fa-times-circle" style={{ fontSize: 20, color: 'red' }} />
                }
                </td>
                <td>

                <ListUserModal
                show={this.state.modalShow}
                onHide={() => this.setState({ modalShow: false })}
                data={data.alloed_users}
                />

                {
                data.user_type=="specific"?
                data.alloed_users.length==0?
                    "All users"
                    :
                    <button className="btn btn-sm btn-primary" onClick={()=>this.setState({modalShow:true})}>Show </button>
                :
                data.user_type
                }
                
                </td>
                <td>
                    <button className="btn-sm btn-outline-primary" onClick={this.edit}>
                    <i className="fas fa-edit " ></i>
                    </button>
                    <span>&nbsp;</span>
                    <button className="btn-sm btn-outline-danger" onClick={this.delete}>
                    <i className="fas fa-trash"></i>
                    </button>
                </td>
            </tr>
        )
    }
}

export default class Promocode extends Component {
    constructor(){
        super()
        this.state={
            data:[],
            next:null,
            prev:null,
            loading:true,
            promocode:'',
            discount:'',
            is_active:false,

            edit:false,
            id:'',

            fortenant:false,
            foroutsider:false,
            individual:false,
            userlist:[],
            recurrence:"",
            ex_date:"",

            modalShow:false,

            
        }
    }
    edit=(data)=>{
        NotificationManager.info("Please make changes in edit section","Info",3000)

        // console.log('Data ',data);
        var date
        if(!data.expiry_date){
            date=""
        }else{
            var expiryDate = new Date(data.expiry_date)

            var date = JSON.stringify(expiryDate)
            date = date.slice(1,11)
        }
        
        // console.log(typeof expiryDate.getDate())
        // console.log(expiryDate.getDate())
        // console.log(expiryDate.getMonth())
        // console.log(expiryDate.getFullYear())
        // expiryDate = expiryDate.getDate()+"-"+expiryDate.getMonth()+"-"+expiryDate.getFullYear()
        // console.log('new ',date);
        
        this.setState({
            edit:true,
            id:data.id,
            promocode:data.code,
            discount:data.disc_perc,
            ex_date:date,
            recurrence:data.recurrence,
            is_active:data.is_active,
        })
        // console.log('Edit parent data ',data);
    }
    

    EditDay=()=>{
        // console.log('state ',this.state);
        // return false
        this.loading(true)
        
        let is_active
        if(this.state.is_active === "true"){
            is_active = 1
         }
         else{
            is_active = 0
         }
        //  console.log('active ',this.state.is_active);
         console.log('updating date ', this.state.ex_date);
        //  return false
        let ex_date
        if(this.state.ex_date){
            ex_date= this.state.ex_date+" 00:00:00"
        }else{
            ex_date=""
        }
        var bodyFormData = new FormData();
        bodyFormData.set('id', this.state.id);
        bodyFormData.set('is_active', is_active);
        
        bodyFormData.set('disc_perc', this.state.discount);
        bodyFormData.set('recurrence', this.state.recurrence);
        bodyFormData.set('ex_date',ex_date);

        axios.put(
            Base.url + 'PromoCodes/',
            bodyFormData,
            {
                headers: {
                    'Authorization': 'Token ' + localStorage.getItem('Token'),
                }
            }
        )
        .then(response =>{
            // console.log('response : ',response);
                if(response.data.Status){
                    NotificationManager.success( response.data.Message,'Success : ',3000)
                    this.clearEdit()

                    this.fetchAllData()
                    this.loading(false)


                }else{
                    console.log(response.data.Message);
                    NotificationManager.error('Error : ', response.data.Error, 10000)

                    this.loading(false)
                }
        })
        .catch(error=>{
            console.log(error);
        })
    }

    clearEdit=()=>{
        this.setState({
            edit:false,
            id:'',
            promocode:'',
            discount:'',
            is_active:false,

            fortenant:false,
            foroutsider:false,
            individual:false,
            userlist:[],
            recurrence:"",
            ex_date:"",
        })
        

    }
    deleteDay = (data)=>{
        // console.log('Delete parent data ',data);
        
        axios.delete(
            Base.url + 'PromoCodes/?id='+data.id,
            {
                headers: {
                    'Authorization': 'Token ' + localStorage.getItem('Token'),
                }
            }
        )
        .then(response =>{
            // console.log('response : ',response);
                if(response.data.Status){
                    NotificationManager.success( response.data.Message,'Success : ',3000)
                    this.fetchAllData()
                    this.loading(false)
                }else{
                    console.log(response.data.Message);
                    NotificationManager.error('Error : ', response.data.Error, 10000)

                    this.loading(false)

                }
        })
        .catch(error=>{
            console.log(error);
        })
    }


    loading=(args)=>{
        this.setState({
            loading:args
        })
    }

    componentDidMount(){
        
        this.fetchAllData()
    }

    next=()=>{
        this.loading(true)
        axios.get(
          this.state.next.replace(/^http:\/\//i, 'https://'),
          { 
              headers: { 
                'Authorization': 'Token '+localStorage.getItem('Token'),
              } 
          }
        ).then(response =>{
          this.setState({
            data:response.data.results,
            next:response.data.next,
            prev:response.data.previous,
            loading:false, 

          })
        })
        .catch(error =>{
            NotificationManager.error('Error : ', error, 10000);
        })
    }

    prev=()=>{
        this.loading(true)
        axios.get(
          this.state.prev.replace(/^http:\/\//i, 'https://'),
          { 
              headers: { 
                  'Authorization': 'Token '+localStorage.getItem('Token'),
              } 
          }
        ).then(response =>{
          this.setState({
            data:response.data.results,
            next:response.data.next,
            prev:response.data.previous,
            loading:false,
          })
        })
        .catch(error =>{
            NotificationManager.error('Error : ', error, 10000);
        })
    }

    fetchAllData(){
        this.loading(true)
        axios.get(
            Base.url + 'PromoCodes/?keyword=',
            {
                headers: {
                    'Authorization': 'Token ' + localStorage.getItem('Token'),
                }
            }
        ).then(response => {
            // console.log('Response all :', response);
            // console.log('Response all :', response.data.results);

            this.setState({
                data: response.data.results,
                next: response.data.next,
                prev: response.data.previous,
                loading:false,
            })
        }).catch(error => {
            console.log('Error loading quotation count: ', error);
            NotificationManager.error('Error : ', error, 10000);
        })
    }

    onChange=(e)=>{
        this.setState ({
            [e.target.name]:e.target.value
        }
        )
    }
    
    addPromocode=()=>{
        this.loading(true)
        // console.log('PromoCodes/');
        // console.log("fortenant : ",this.state.fortenant)
        // console.log("foroutsider : ",this.state.foroutsider)
        // console.log("userlist : ",this.state.userlist)
        // console.log("recurrence : ",this.state.recurrence)
        // console.log("ex_date : ",this.state.ex_date)
        // ok
        

        if(isNaN(this.state.discount)){
            NotificationManager.warning('Expected : ', 'Numeric value for discound', 3000)

            return false
        }
        // this.clearEdit()
        // return false

        
        var bodyFormData = new FormData();
        bodyFormData.set('promo_code', this.state.promocode);
        bodyFormData.set('disc_perc', this.state.discount);
        bodyFormData.set('for_tenants', this.state.fortenant);
        bodyFormData.set('for_outsider', this.state.foroutsider);
        bodyFormData.set('allowed_users', JSON.stringify(this.state.userlist));
        bodyFormData.set('recurrence', this.state.recurrence);
        if(!this.state.ex_date==""){
            bodyFormData.set('ex_date', this.state.ex_date+" 00:00:00");
        }
        
        // bodyFormData.set('is_active', this.state.is_active);
        // bodyFormData.set('user_type', this.state.user_type);

        axios.post(
            Base.url + 'PromoCodes/',
            bodyFormData,
            {
                headers: {
                    'Authorization': 'Token ' + localStorage.getItem('Token'),
                }
            }
        )
        .then(response =>{
            // console.log('response : ',response);
                if(response.data.Status){
                    NotificationManager.success( response.data.Message,'Success : ',5000)
                    this.fetchAllData()
                    this.loading(false)

                    this.clearEdit()
                }else{
                    console.log(response.data.Message);
                    console.log(response.data.Error);
                    NotificationManager.error('Error : ', response.data.Error, 10000)

                    this.loading(false)
                }
        })
        .catch(error=>{
            console.log(error);
        })
    }
    render() {
        return (
            <div>
                {/* <NotificationContainer/> */}
                <NavigationItems />
                {/* Main content */}
                <div className="main-content">
                    <PageHeader pageName="Promocode" />

                    <div className="header bg-gradient-primary pb-8 pt-5 pt-md-8">
                        <div className="container-fluid">
                            <div className="header-body">
                                {/* Card stats */}
                                <div className="row">
                                    <div className="col-xl-3 col-lg-6">
                                    </div>
                                    <div className="col-xl-3 col-lg-6">
                                    </div>
                                    <div className="col-xl-3 col-lg-6">
                                    </div>
                                    <div className="col-xl-3 col-lg-6">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Page content */}
                    <div className="container-fluid mt--7">
                        <div className="row">
                            <div className="col-xl-8 mb-5 mb-xl-0">
                                <div className="card shadow">
                                    <div className="card-header border-0">
                                        <div className="row align-items-center">
                                            <div className="col">
                                                <h3 className="mb-0">Promocode</h3>
                                            </div>
                                            <div className="col text-right">
                                            {this.state.prev==null?<button disabled={true} className="btn btn-sm btn-primary">Prev</button>:<button className="btn btn-sm btn-primary" onClick={this.prev}>Prev</button>}
                                            {this.state.next==null?<button disabled={true} className="btn btn-sm btn-primary">Next</button>:<button className="btn btn-sm btn-primary" onClick={this.next}>Next</button>}
                                            </div>
                                        </div>
                                    </div>
                                    {this.state.loading?<WaveLoading/>:
                                    <div className="table-responsive">
                                        {/* Projects table */}
                                        <table className="table align-items-center table-flush">
                                            <thead className="thead-light">
                                                <tr>
                                                    <th scope="col">Promocode</th>
                                                    <th scope="col">Discound Percentage</th>
                                                    <th scope="col">active</th>
                                                    <th scope="col">Users</th>
                                                    <th scope="col">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.data.map((item,index)=><Items 
                                                key={index} 
                                                data={item}
                                                Edit={this.edit}
                                                Delete={this.deleteDay}
                                                />)
                                                }
                                                {/* <tr>
                                                    <th scope="row">vs2gs4</th>
                                                    <td>85%</td>
                                                    <td><i className="fa fa-check-circle" style={{ fontSize: 20, color: 'green' }} /></td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">fd#2hj</th>
                                                    <td>35%</td>
                                                    <td><i className="fa fa-check-circle" style={{ fontSize: 20, color: 'green' }} /></td>
                                                </tr> */}
                                            </tbody>
                                        </table>
                                    </div>
    }
                                </div>
                            </div>
                            <div className="col-xl-4">
                                <div className="card shadow">
                                    <div className="card-header bg-transparent">
                                        <div className="row align-items-center">
                                            <div className="col">
                                                {
                                                this.state.edit?
                                                <h2><i className="fas text-red fa-window-close pr-4" onClick={this.clearEdit}></i>Edit Promocode</h2>
                                                :
                                                <a className="card-header bg-transparent"><h2>Add Promocode</h2></a>
                                                }

                                            </div>
                                        </div>
                                        <form role="form">
                                            
                                            <div className="form-group">
                                                <div className="input-group input-group-alternative mb-3">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text"></span>
                                                    </div>
                                                    
                                                    <input disabled={this.state.edit} name="promocode" value={this.state.promocode} onChange={this.onChange} className="form-control" placeholder="promocode" type="text" />
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <div className="input-group input-group-alternative mb-3">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text"></span>
                                                    </div>
                                                    <input  name="discount" value={this.state.discount} onChange={this.onChange} className="form-control" placeholder="Discound Percentage" type="number" />
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <div className="input-group input-group-alternative mb-3">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text"></span>
                                                    </div>
                                                    <input  name="recurrence" value={this.state.recurrence} onChange={this.onChange} className="form-control" placeholder="Recurrence" type="number" />
                                                </div>
                                            </div>
                                            <label>Expiry date (optional)</label>
                                            <div className="form-group">
                                                <div className="input-group input-group-alternative mb-3">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text"></span>
                                                    </div>
                                                    <input className="form-control" type="date" value={this.state.ex_date} onChange={(event) => this.setState({ex_date: event.target.value})}/>
                                                </div>
                                            </div>
                                            {this.state.edit?
                                            ""
                                            :
                                            <>
                                            
                                            <label>Select for specific users (optional)</label>
                                            <div style={{display:"flex",flexDirection:"row"}}>
                                                <span onClick={(event) => this.setState({fortenant: !this.state.fortenant,foroutsider:false,individual: false} )} style={{ cursor:"pointer", boxShadow: '0px 1px 2px 0px grey', padding: 10, display: 'flex', height: '100%', flex: 1, justifyContent: 'center', borderBottomLeftRadius: 10, borderTopLeftRadius: 10,backgroundColor:this.state.fortenant?'#6072E4':'white',color:this.state.fortenant?'white':'black' }} >Tenants</span>
                                                <span onClick={(event) => this.setState({foroutsider: !this.state.foroutsider,fortenant:false,individual: false} )}  style={{ cursor:"pointer", boxShadow: '0px 1px 2px 0px grey', padding: 10, display: 'flex', flex: 1, justifyContent: 'center', backgroundColor:this.state.foroutsider?'#6072E4':'white',color:this.state.foroutsider?'white':'black' }} >Outsiders</span>
                                                <span onClick={(event) => this.setState({fortenant: false,foroutsider: false,individual: true,modalShow:true} )}  style={{ cursor:"pointer", boxShadow: '0px 1px 2px 0px grey', padding: 10, display: 'flex', flex: 1, justifyContent: 'center', borderBottomRightRadius: 10, borderTopRightRadius: 10,backgroundColor:this.state.individual?'#6072E4':'white',color:this.state.individual?'white':'black' }} >Individual</span>
                                            </div>
                                            </>
                                            }
                                            
                                            <MyVerticallyCenteredModal
                                            show={this.state.modalShow}
                                            onHide={() => this.setState({ modalShow: false })}
                                            setlist={(list)=>this.setState({userlist:list})}
                                            />

                                            
                                            <br/>
                                            {
                                            this.state.edit?
                                            <select className="form-control-sm form-control" style={{borderColor:'#fafafa',boxShadow:'0px 2px 1px #ededed',paddingLeft:18}}  name="is_active" value={this.state.is_active} onChange={this.onChange}>
                                                <option  value="false" >Deactivate</option>
                                                <option  value="true" >Active</option>
                                            </select>
                                            :
                                            ""
                                            }
                            
                                            <div className="text-center text-muted mb-4">
                                                {/* <small>Or sign up with credentials</small> */}
                                            </div>
                                        </form>
                                        <div className="text-center">
                                            {
                                            this.state.edit?
                                            <button type="button" className="btn btn-primary mt-4" onClick={this.EditDay}>Save</button>
                                            :
                                            <button type="button" className="btn btn-primary mt-4" onClick={this.addPromocode}>Add</button>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>

        )
    }
}
